import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { LicenseInfo } from '@mui/x-license-pro';
import Productivity from './Pages/Productivity';
import "./style.bundle.css";
import "./plugin.bundle.css";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './login/login';
import ResetPW from './login/resetpw';
import ConfirmPW from './login/pwconfirm';
import NewPW from './login/newpw';
import SignUp from './login/signujp';
import ProtectedRoute from './common/privateRoute';

document.title = "삼성중공업 - 생산성시스템";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          //  <ProtectedRoute>
            <Productivity />
          // </ProtectedRoute>
        } />
        <Route path="/prdlogin" element={<SignIn />} />
        <Route path="/prdreset-password" element={<ResetPW />} />
        <Route path="/prdpassword-confirmation" element={<ConfirmPW />} />
        <Route path="/prdnew-password" element={<NewPW />} />
        <Route path="/prdsignup" element={<SignUp />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
